import { useContext } from 'react';

import { DiscoveryTabContext } from 'providers/helpers/contexts';
import { IDiscoveryTab } from 'providers/helpers/models';

const useDiscoveryTab = (): IDiscoveryTab => useContext<IDiscoveryTab>(DiscoveryTabContext);

export default useDiscoveryTab;
